import { Base64 } from 'js-base64';
import { isValidBase64, momentTzToRailsTz } from '@/common';
import { useRoute } from 'vue-router';
import { ref, computed } from 'vue';

export function useGate() {
  const route = useRoute();

  const email = computed(() => {
    const token = route.query.et;
    if (!token || typeof token !== 'string' || !isValidBase64(token)) return null;
    try {
      return Base64.decode(token);
    } catch {
      return null;
    }
  });

  const timezone = computed(() => {
    const jsTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return momentTzToRailsTz(jsTz);
  });

  const claimedUser = computed(() => {
    const c = route.query.c;
    return !!c && typeof c === 'string' && isValidBase64(c);
  });

  const invitationToken = computed(() => {
    const invt = route.query.invt;
    if (!invt || typeof invt !== 'string') return null;
    return invt.split('/')[0];
  });

  return {
    email,
    timezone,
    claimedUser,
    invitationToken,
  };
}
